import React from 'react';
import styled from 'styled-components';

const BaseInput = styled.input`
  position: relative;
  left: 15px;
  top: -4px;
  z-index: 0;
  -webkit-appearance: none;
  height: 0px;
  width: 0px;
  & + label:before {
    width: 15px;
    height: 15px;
    border-radius: 5px;
    border: 2px solid #000;
    background-color: #fff;
    display: block;
    content: '';
    float: left;
    margin-right: 5px;
    z-index: 5;
    position: relative;
    cursor: pointer;
  }
  &:checked + label:before {
    box-shadow: inset 0px 0px 0px 3px #fff;
    background-color: #000;
  }
  &:focus + label:before {
    border-width: 3px;
  }
  & + label {
    cursor: pointer;
    overflow-wrap: anywhere;
  }
`;

/**
 * Styled checkbox with keyboard support for Enter-triggered toggling.
 * @param inputProps Native input props plus `label`.
 * @returns Checkbox and associated label.
 */
const Checkbox = (inputProps: any) => {
  return (
    <>
      <BaseInput
        onKeyUp={e => {
          if (e.key === 'Enter') {
            inputProps.onChange();
          }
        }}
        tabIndex={0}
        type="checkbox"
        id={inputProps.name}
        name={inputProps.name}
        {...inputProps}
      />
      <label htmlFor={inputProps.name}>{inputProps.label}</label>
    </>
  );
};

export default Checkbox;
